module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-stream"
  }, [_c('div', {
    staticClass: "dropdown",
    attrs: {
      "title": _vm.$t('button_settings_title')
    }
  }, [_c('i', {
    staticClass: "icon-settings-menu icons",
    attrs: {
      "data-settings-dropdown": ""
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownVisible),
      expression: "dropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('audio-device-select'), _vm._v(" "), _c('video-device-select'), _vm._v(" "), _c('options-menu-select', {
    attrs: {
      "initialMode": true
    }
  })], 1)]), _vm._v(" "), _c('stream', {
    attrs: {
      "source": _vm.sourceStream,
      "is-local-stream": true,
      "id": _vm.localPeerId,
      "local-initial-mode": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62225338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyStream.vue
// module id = 370
// module chunks = 1